<div style="background-color: black; padding-top: 130px;">
    <div class="container">
        <div class="row">
            <div class="col-4">List of Shows</div>
            <div class="col-4">List of Buttons for show</div>
            <div class="col-4">Add buttons</div>
        </div>
        
    </div>
</div>